import { Modal } from '@aon/aon-tws-common-ui';
import styled from 'styled-components';

const ColumnLayoutModal = styled(Modal)`
	.modal-body {
		flex-direction: column;
	}
`;
ColumnLayoutModal.displayName = 'ColumnLayoutModal';

export { ColumnLayoutModal };
